import React from 'react';
import { StyleSheet, Text, View } from './base_components';

import LinkText from './buttons/link_text';

const styles = StyleSheet.create({
  breadcumb: {
    marginTop: '2rem',
    marginLeft: '3rem',
    marginRight: '3rem',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignSelf: 'stretch',
    overflow: 'hidden',
    minWidth: 0,
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  sep: { marginLeft: '0.5em', marginRight: '0.5em' },
  link: { maxWidth: '100%' },
  pathLink: {
    color: 'var(--link-text-color)',
    fontSize: '1.5rem',
    lineHeight: '2.5rem',
    fontWeight: '600',
    textDecoration: 'underline',
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
    maxWidth: '100%',
  },
  pathText: {
    color: '#555',
    fontSize: '1.5rem',
    lineHeight: '2.5rem',
    fontWeight: '600',
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
    maxWidth: '100%',
  },
});

type Props = { style?: any; textStyle?: any; linkStyle?: any; list: any[] };
export default function Breadcrumb(props: Props) {
  const { style, textStyle, linkStyle, list } = props;

  const crumbs = list.map((part, i) => {
    let name: any = null;
    if (part?.url) {
      name = (
        <LinkText
          style={styles.link}
          textStyle={[styles.pathLink, linkStyle]}
          url={part.url}
          text={part.text}
        />
      );
    } else {
      name = (
        <Text style={[styles.pathText, textStyle]}>{part?.text ?? part}</Text>
      );
    }
    return (
      <React.Fragment key={i}>
        {i > 0 ? (
          <Text style={[styles.sep, styles.pathText, textStyle]}>&gt;</Text>
        ) : null}
        {name}
      </React.Fragment>
    );
  });

  return <View style={[styles.breadcumb, style]}>{crumbs}</View>;
}
